/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import LeftPanel from 'components/LeftPanel';
import RightPanel from 'components/RightPanel';
import { calculateActualCoverImage } from 'utils';
import { useUser } from 'hooks';
import { CoverImage, Wrapper } from './styles';
import { preConectTabbingStatus, preConnectAsterisk, verifyCallWithoutTabbing, verifyScheduling } from './helper';
import Modal from 'components/Modal';
import { ipcIsLogged, ipcWindowShow } from 'utils/ipcevents';
import { Logs } from 'utils/logs';

const Dialer: React.FC = () => {
  const { status } = useUser()
  const initialConnection = async () => {
    await preConnectAsterisk(status);
    await preConectTabbingStatus();
    const callWithoutTabbing = await verifyCallWithoutTabbing();

    if (!callWithoutTabbing) {
      await verifyScheduling();
    }
  }

  const clearSessionStorage = () => {
    sessionStorage.removeItem('dynamicFields');
    sessionStorage.removeItem('statusFields');
  }

  useEffect(() => {
    ipcWindowShow();
    clearSessionStorage();
    initialConnection();
    ipcIsLogged();
  }, []);

  return (
    <Wrapper>
      <Logs />
      <CoverImage src={calculateActualCoverImage()} />
      <LeftPanel />
      <RightPanel />
      <Modal />
    </Wrapper>
  );
}

export default Dialer;
